const LIST_ACTION_TYPES = {
  FETCH_LIST: "FETCH_LESSONS_LIST",
  FETCH_LIST_REQUEST: "FETCH_LESSONS_LIST_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_LESSONS_LIST_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_LESSONS_LIST_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_LESSONS_LIST",
}

export default LIST_ACTION_TYPES
